module.exports = __webpack_public_path__ + "img/ttd.e039915d.png";